import { useEffect } from 'react';

import { startTynkPixel } from './tynk-pixel';

export {
  assinaturaAtiva,
  contaInterna,
  entDaSessaoFapi,
  marcarPaginaPrivada,
  marcarPaginaPublica,
  normalizarCaminho,
  PIXEL_ID,
  podeAtivar,
  rotaDeveSerIgnorada,
  sanitizarReferrer,
  startTynkPixel,
  temPaginaPrivada,
  temPaginaPublica,
  temParametroSensivel,
  tipoDoUsuario,
  type UserType,
} from './tynk-pixel';

/**
 * Monta o rastreamento (pixel 01 + GTM pelo `/tk`) no app web, ao lado do <Crisp />. Toda a lógica (guarda de host,
 * identidade, limpeza da URL, PageView por rota, rotas fora) vive em startTynkPixel — aqui é só o gatilho no mount, uma vez.
 */
export function TynkPixel() {
  useEffect(() => {
    startTynkPixel();
  }, []);

  return null;
}
